footerScrollAnimation();
function footerScrollAnimation() {
  const params = {
    triggerClass: ".footer__trigger-2",
    maskClass: ".footer__video-mask",
    /*scaleMultiplier: 6,*/
    scaleMultiplier: 6,
  };

  let state = {
    render: false,
    scale: 100,
    /*lerpScale: 1200,*/
    lerpScale: 1200,
    positionX: 0,
    positionY: 0,
  };

  const trigger = document.querySelector(params.triggerClass);
  const mask = document.querySelector(params.maskClass);

  let wrapper = document.querySelector('.main-page__origins-content');

  if (!wrapper) {
    wrapper = document.body;
  }

  // mask.setAttribute("style", "  -webkit-mask-size: 600%; mask-size: 600%;");
  mask.setAttribute(
    "style",
    " -webkit-mask-size: " +
      state.lerpScale +
      "%; mask-size: " +
      state.lerpScale +
      "%;"
  );

  window.addEventListener("scroll", function () {
    const triggerHeight = trigger.clientHeight;
    const bodyHeight = wrapper.clientHeight;
    const scrollPosition = window.scrollY;

    const position = Math.abs(bodyHeight - scrollPosition) - window.innerHeight;
    const progress = (position / triggerHeight) * 100;

    if (progress <= 200) {
      state.render = true;

      if (progress > 0.5) {
        state.scale = progress * params.scaleMultiplier;
      } else {
        state.scale = 0.5 * params.scaleMultiplier;
      }
    } else {
      state.render = false;
    }
  });

  function step() {
    if (state.render === true) {
      state.lerpScale = lerp(state.lerpScale, state.scale, 0.1);

      mask.setAttribute(
        "style",
        " -webkit-mask-size: " +
          state.lerpScale +
          "%; mask-size: " +
          state.lerpScale +
          "%;"
      );
    }
    window.requestAnimationFrame(step);
  }
  window.requestAnimationFrame(step);

  function lerp(start, end, amt) {
    return (1 - amt) * start + amt * end;
  }
}
